import { inject, Injectable, signal } from '@angular/core';
import { ArticleDto } from '@shared/interfaces/dtos/article-dto.interface';
import { ArticlesService } from './articles.service';
import { YearsService } from './years.service';
import { ErrorHandler } from '@core/services/error-handler.service';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FormOptionsService {
  private readonly providers = {
    yearsService: inject(YearsService),
    articlesService: inject(ArticlesService),
    errorHandler: inject(ErrorHandler),
  };
  public budgetArticles = signal<ArticleDto[]>([]);

  public init(): void {
    this.setBudgetArticles();
  }

  public refresh(option: 'articles' | 'all' = 'all'): void {
    switch (option) {
      case 'articles':
        this.setBudgetArticles();
        break;
      case 'all':
        this.setBudgetArticles();
        break;
      default:
        throw new Error(`Invalid option: ${option}`);
    }
  }

  private setBudgetArticles(
    year: number = this.providers.yearsService.currentYear(),
  ): void {
    this.providers.articlesService
      .fetchAll(
        {
          page: 1,
          limit: 10_000,
          year: year ?? this.providers.yearsService.currentYear(),
        },
        { useCache: false },
      )
      .pipe(
        map((articles: ArticleDto[]) => {
          return articles.sort((a, b) => (a.code > b.code ? 1 : -1));
        }),
      )
      .subscribe({
        next: (articles: ArticleDto[]) => {
          this.budgetArticles.set(articles);
        },
        error: (error) => {
          this.providers.errorHandler.handle(error.error);
        },
      });
  }

  public get articles(): ArticleDto[] {
    return this.budgetArticles();
  }
}
